import React from 'react';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { tokens } from 'theme';
import { ScreenTitle, ViewModeChanger } from 'components';
import { COLUMNS, INITIAL_PAGE_SIZE } from './constants/constants';
import { useAppDispatch, useAppSelector, useTheme } from 'hooks';
import { usePatientsData } from './hooks/hooks';
import { ViewMode } from 'types/enums';
import { patientsActions } from 'utils/store';
import styles from './styles.module.sass';

export const Patients = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { patientsFormattedData, isDataLoading, onFilterModelChangeHandler, onPaginationChangeHandler } =
    usePatientsData();
  const { totalCount, patientsViewMode, monitoringFacilityId } = useAppSelector(({ patients }) => patients);
  const dispatch = useAppDispatch();

  const handleFacilityChange = (facilityId: string) => {
    dispatch(patientsActions.setMonitoringFacilityId(facilityId));
  };

  const handleModeChange = (mode: ViewMode) => {
    dispatch(patientsActions.setPatientsViewMode(mode));
  };
  const shouldHideTable = patientsViewMode === ViewMode.ADMIN && !monitoringFacilityId;

  return (
    <>
      <ScreenTitle title='Patients' />
      <ViewModeChanger
        viewMode={patientsViewMode}
        onModeChange={handleModeChange}
        onMonitoringFacilityChange={handleFacilityChange}
      />
      <Box
        className={styles.details}
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
            overflowY: 'hidden',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '0.4em',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: colors.dashboard.secondary,
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.dashboard.secondary,
            borderBottom: 'none',
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.dashboard.secondary,
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${colors.grey[100]} !important`,
          },
          '& .MuiTablePagination-root::-webkit-scrollbar': {
            width: '0.4em',
          },
          '& .MuiTablePagination-root::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '& .MuiTablePagination-root::-webkit-scrollbar-thumb': {
            backgroundColor: colors.dashboard.secondary,
          },
        }}
      >
        {!shouldHideTable && (
          <DataGrid
            rowHeight={200}
            rows={patientsFormattedData}
            columns={COLUMNS}
            initialState={{
              pagination: { paginationModel: { pageSize: INITIAL_PAGE_SIZE, page: 0 } },
            }}
            pageSizeOptions={[INITIAL_PAGE_SIZE, 25, 50]}
            sx={{ overflowX: 'auto' }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{ toolbar: { showQuickFilter: true } }}
            loading={isDataLoading}
            onFilterModelChange={onFilterModelChangeHandler}
            onPaginationModelChange={onPaginationChangeHandler}
            paginationMode='server'
            rowCount={totalCount}
          />
        )}
      </Box>
    </>
  );
};
